/* Livraria Raízes Cristãs · interações do tema "Raízes"
   Tudo funciona sem JavaScript (formulários e links comuns); aqui entram o carrinho
   sem recarregar, a troca de formato, a busca instantânea, os filtros e as animações. */
(() => {
  'use strict';

  const tema = window.tema || { rotas: {}, textos: {} };
  const $ = (seletor, raiz = document) => raiz.querySelector(seletor);
  const $$ = (seletor, raiz = document) => Array.from(raiz.querySelectorAll(seletor));
  const reduzirMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ponteiroFino = window.matchMedia('(hover: hover) and (pointer: fine)');
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const atraso = (fn, ms) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  /* ── Revelar ao rolar ─────────────────────────────────────────── */
  const observadorRevelar =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entradas) => {
            entradas.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.remove('pendente');
                e.target.classList.add('revelado');
                observadorRevelar.unobserve(e.target);
              }
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
        )
      : null;
  const revelar = (raiz = document) => {
    $$('[data-revelar]:not(.revelado):not(.pendente)', raiz).forEach((el) => {
      if (!observadorRevelar || el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('revelado');
        return;
      }
      el.classList.add('pendente');
      observadorRevelar.observe(el);
    });
  };

  /* ── Gavetas (menu, carrinho, filtros) com <dialog> ───────────── */
  const abrirGaveta = (dialogo) => {
    if (!dialogo || dialogo.open) return;
    dialogo.classList.remove('saindo');
    dialogo.showModal();
    document.documentElement.classList.add('travado');
    $$(`[aria-controls="${dialogo.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
  };
  const fecharGaveta = (dialogo) => {
    if (!dialogo || !dialogo.open || dialogo.classList.contains('saindo')) return;
    if (reduzirMovimento.matches) return dialogo.close();
    let feito = false;
    const aoTerminar = (e) => e.target === dialogo && terminar();
    const terminar = () => {
      if (feito) return;
      feito = true;
      dialogo.removeEventListener('animationend', aoTerminar);
      dialogo.classList.remove('saindo');
      if (dialogo.open) dialogo.close();
    };
    dialogo.classList.add('saindo');
    dialogo.addEventListener('animationend', aoTerminar);
    setTimeout(terminar, 360);
  };
  document.addEventListener('close', (e) => {
    if (!(e.target instanceof HTMLDialogElement)) return;
    $$(`[aria-controls="${e.target.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$$('dialog.gaveta[open]').length) document.documentElement.classList.remove('travado');
  }, true);
  document.addEventListener('cancel', (e) => {
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('gaveta')) {
      e.preventDefault();
      fecharGaveta(e.target);
    }
  }, true);
  document.addEventListener('click', (e) => {
    const abrir = e.target.closest('[data-abrir]');
    if (abrir) {
      e.preventDefault();
      abrirGaveta(document.getElementById(abrir.dataset.abrir));
      return;
    }
    const fechar = e.target.closest('[data-fechar-gaveta]');
    if (fechar) {
      fecharGaveta(fechar.closest('dialog'));
      return;
    }
    // clique no fundo escurecido (fora do conteúdo da gaveta)
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('gaveta')) {
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) fecharGaveta(e.target);
    }
  });

  /* ── Cabeçalho: sombra ao rolar, submenus e busca ─────────────── */
  const marcarRolagem = () => document.documentElement.classList.toggle('rolado', window.scrollY > 8);
  window.addEventListener('scroll', marcarRolagem, { passive: true });
  marcarRolagem();

  document.addEventListener('toggle', (e) => {
    const aberto = e.target;
    if (!(aberto instanceof HTMLDetailsElement) || !aberto.matches('[data-submenu]') || !aberto.open) return;
    $$('[data-submenu][open]').forEach((d) => d !== aberto && (d.open = false));
  }, true);
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-submenu]')) $$('[data-submenu][open]').forEach((d) => (d.open = false));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-submenu][open]').forEach((d) => {
      d.open = false;
      $('summary', d).focus();
    });
    if (!$('[data-busca-painel]')?.hidden) fecharBusca();
  });

  const painelBusca = $('[data-busca-painel]');
  const campoBusca = $('[data-busca-campo]');
  const resultadosBusca = $('[data-busca-resultados]');
  const botaoBusca = $('[data-abrir-busca]');
  let buscaControle;
  const abrirBusca = () => {
    if (!painelBusca) return;
    painelBusca.hidden = false;
    botaoBusca?.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => campoBusca?.focus());
  };
  const fecharBusca = () => {
    if (!painelBusca) return;
    painelBusca.hidden = true;
    botaoBusca?.setAttribute('aria-expanded', 'false');
  };
  botaoBusca?.addEventListener('click', () => (painelBusca.hidden ? abrirBusca() : fecharBusca()));
  $('[data-fechar-busca]')?.addEventListener('click', fecharBusca);
  document.addEventListener('click', (e) => {
    if (painelBusca && !painelBusca.hidden && !e.target.closest('[data-busca-painel], [data-abrir-busca]')) fecharBusca();
  });
  const buscar = atraso(async (termo) => {
    if (!resultadosBusca) return;
    if (termo.length < 2) {
      resultadosBusca.innerHTML = '';
      return;
    }
    buscaControle?.abort();
    buscaControle = new AbortController();
    try {
      const url = `${tema.rotas.busca}?q=${encodeURIComponent(termo)}&section_id=busca-preditiva&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last`;
      const resposta = await fetch(url, { signal: buscaControle.signal });
      if (!resposta.ok) return;
      const doc = parseHTML(await resposta.text());
      resultadosBusca.innerHTML = $('.preditiva', doc)?.outerHTML || '';
    } catch (erro) {
      if (erro.name !== 'AbortError') resultadosBusca.innerHTML = '';
    }
  }, 220);
  campoBusca?.addEventListener('input', () => buscar(campoBusca.value.trim()));

  /* ── Carrinho sem recarregar ──────────────────────────────────── */
  const gavetaCarrinho = () => document.getElementById('carrinho-gaveta');
  const naPaginaDoCarrinho = () => document.body.classList.contains('modelo-cart');

  const atualizarContador = (quantidade) => {
    $$('[data-contador-carrinho]').forEach((bolha) => {
      bolha.textContent = quantidade;
      bolha.hidden = quantidade === 0;
      bolha.classList.remove('pulou');
      void bolha.offsetWidth;
      bolha.classList.add('pulou');
    });
  };

  const renderizarGaveta = (html) => {
    const dialogo = gavetaCarrinho();
    if (!dialogo || !html) return;
    const novo = $('[data-carrinho-interno]', parseHTML(html));
    const atual = $('[data-carrinho-interno]', dialogo);
    if (novo && atual) atual.replaceWith(novo);
  };

  const pedirCarrinho = async (url, corpo) => {
    const resposta = await fetch(url, {
      method: 'POST',
      headers: corpo instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: corpo instanceof FormData ? corpo : JSON.stringify(corpo),
    });
    const dados = await resposta.json();
    if (!resposta.ok || dados.status) throw new Error(dados.description || dados.message || tema.textos.erro);
    return dados;
  };

  const lerCarrinho = async () => {
    const resposta = await fetch(`${tema.rotas.carrinho}.js`, { headers: { Accept: 'application/json' } });
    return resposta.json();
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-adicionar]');
    if (!form || naPaginaDoCarrinho()) return;
    e.preventDefault();
    const botoes = $$('[type="submit"]', form).concat(form.id ? $$(`[form="${form.id}"]`) : []);
    const principal = e.submitter || botoes[0];
    const textoOriginal = principal ? principal.innerHTML : '';
    botoes.forEach((b) => b.classList.add('carregando'));
    const dados = new FormData(form);
    dados.append('sections', 'carrinho-gaveta');
    dados.append('sections_url', window.location.pathname);
    try {
      const resposta = await pedirCarrinho(`${tema.rotas.adicionar}.js`, dados);
      renderizarGaveta(resposta.sections?.['carrinho-gaveta']);
      const carrinho = await lerCarrinho();
      atualizarContador(carrinho.item_count);
      if (principal?.classList.contains('pilula-formato') || principal?.classList.contains('pilula-compra')) {
        principal.classList.add('adicionado');
        setTimeout(() => principal.classList.remove('adicionado'), 1600);
      }
      abrirGaveta(gavetaCarrinho());
    } catch (erro) {
      window.alert(erro.message || tema.textos.erro);
    } finally {
      botoes.forEach((b) => b.classList.remove('carregando'));
      if (principal && textoOriginal) principal.innerHTML = textoOriginal;
    }
  });

  document.addEventListener('click', async (e) => {
    const abrir = e.target.closest('[data-abrir-carrinho]');
    if (abrir && gavetaCarrinho() && !naPaginaDoCarrinho()) {
      e.preventDefault();
      abrirGaveta(gavetaCarrinho());
      return;
    }
    const alterar = e.target.closest('#carrinho-gaveta [data-quantidade]');
    if (!alterar) return;
    const item = alterar.closest('[data-chave]');
    const lista = alterar.closest('.carrinho-itens');
    lista?.classList.add('atualizando');
    try {
      const resposta = await pedirCarrinho(`${tema.rotas.alterar}.js`, {
        id: item.dataset.chave,
        quantity: Number(alterar.dataset.quantidade),
        sections: 'carrinho-gaveta',
        sections_url: window.location.pathname,
      });
      renderizarGaveta(resposta.sections?.['carrinho-gaveta']);
      atualizarContador(resposta.item_count);
    } catch (erro) {
      lista?.classList.remove('atualizando');
      window.alert(erro.message || tema.textos.erro);
    }
  });

  // página /cart: quantidades atualizam sozinhas
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-qtd-pagina]')) e.target.form?.requestSubmit($('[name="update"]', e.target.form) || undefined);
  });

  /* ── Página do livro: formato, preço, galeria e barra de compra ─ */
  const iniciarProduto = (secao) => {
    const json = $('[data-produto-json]', secao);
    if (!json) return;
    const variantes = JSON.parse(json.textContent).variantes;
    const campoId = $('[data-variante-id]', secao);
    const preco = $('[data-preco]', secao);
    const trilho = $('[data-galeria-trilho]', secao);
    const miniaturas = $$('[data-ir-para]', secao);
    const itensGaleria = $$('.galeria__item', secao);

    const irPara = (indice, suave = true) => {
      const item = itensGaleria[indice];
      if (!trilho || !item) return;
      trilho.scrollTo({ left: item.offsetLeft - trilho.offsetLeft, behavior: suave && !reduzirMovimento.matches ? 'smooth' : 'auto' });
      miniaturas.forEach((m, i) => m.classList.toggle('ativa', i === indice));
    };
    miniaturas.forEach((m) => m.addEventListener('click', () => irPara(Number(m.dataset.irPara))));
    if (trilho && miniaturas.length) {
      trilho.addEventListener('scroll', atraso(() => {
        const indice = Math.round(trilho.scrollLeft / trilho.clientWidth);
        miniaturas.forEach((m, i) => m.classList.toggle('ativa', i === indice));
      }, 80), { passive: true });
    }

    const aplicar = (variante) => {
      if (!variante) return;
      campoId.value = variante.id;
      const de = $('[data-preco-de]', preco);
      $('[data-preco-por]', preco).textContent = variante.preco;
      if (de) {
        de.hidden = !variante.precoDe;
        de.textContent = variante.precoDe || '';
      }
      preco.classList.remove('mudou');
      void preco.offsetWidth;
      preco.classList.add('mudou');
      $$('[data-botao-adicionar]', secao).forEach((b) => (b.disabled = !variante.disponivel));
      const texto = $('[data-botao-texto]', secao);
      if (texto) texto.textContent = variante.disponivel ? tema.textos.adicionar : tema.textos.esgotado;
      $$('[data-barra-formato]', secao).forEach((el) => (el.textContent = variante.titulo));
      $$('[data-barra-preco]', secao).forEach((el) => (el.textContent = variante.preco));
      $$('[data-aviso-formato]', secao).forEach((el) => (el.hidden = (el.dataset.avisoFormato === 'digital') !== variante.digital));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variante.id);
      window.history.replaceState({}, '', url);
      // capa do formato escolhido (a foto do e-book tem "e-book" no texto alternativo)
      const chave = variante.digital ? 'e-book' : 'livro físico';
      const alvo = itensGaleria.findIndex((item) => (item.dataset.midiaAlt || '').includes(chave));
      if (alvo >= 0) irPara(alvo);
    };
    $$('[data-formato]', secao).forEach((radio) =>
      radio.addEventListener('change', () => aplicar(variantes.find((v) => String(v.id) === radio.value))),
    );

    $$('[data-quantidade-campo]', secao).forEach((caixa) => {
      const campo = $('input', caixa);
      $$('[data-passo]', caixa).forEach((b) =>
        b.addEventListener('click', () => {
          campo.value = Math.max(1, Math.min(99, (Number(campo.value) || 1) + Number(b.dataset.passo)));
        }),
      );
    });

    // inclinação 3D da capa acompanhando o mouse
    if (ponteiroFino.matches && !reduzirMovimento.matches) {
      $$('[data-inclinar]', secao).forEach((item) => {
        item.addEventListener('pointermove', (e) => {
          const r = item.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - 0.5;
          const y = (e.clientY - r.top) / r.height - 0.5;
          item.style.setProperty('--ry', `${(x * 16).toFixed(2)}deg`);
          item.style.setProperty('--rx', `${(-y * 10).toFixed(2)}deg`);
        });
        item.addEventListener('pointerleave', () => {
          item.style.setProperty('--ry', '0deg');
          item.style.setProperty('--rx', '0deg');
        });
      });
    }

    // barra fixa de compra quando o botão principal sai da tela
    const barra = $('[data-barra-compra]', secao);
    const botaoPrincipal = $('.produto__adicionar', secao);
    if (barra && botaoPrincipal) {
      let visivel = false;
      let agendado = false;
      const conferir = () => {
        agendado = false;
        const mostrar = botaoPrincipal.getBoundingClientRect().bottom < 0;
        if (mostrar === visivel) return;
        visivel = mostrar;
        barra.classList.toggle('visivel', mostrar);
        barra.setAttribute('aria-hidden', String(!mostrar));
        $$('button', barra).forEach((b) => (b.tabIndex = mostrar ? 0 : -1));
        document.body.classList.toggle('com-barra-compra', mostrar);
      };
      window.addEventListener('scroll', () => {
        if (!agendado) {
          agendado = true;
          requestAnimationFrame(conferir);
        }
      }, { passive: true });
      conferir();
    }
  };
  $$('[data-produto]').forEach(iniciarProduto);

  /* ── Carrosséis ───────────────────────────────────────────────── */
  const iniciarCarrossel = (secao) => {
    const trilho = $('[data-carrossel-trilho]', secao);
    const anterior = $('[data-carrossel-anterior]', secao);
    const proximo = $('[data-carrossel-proximo]', secao);
    if (!trilho || secao.dataset.carrosselPronto) return;
    secao.dataset.carrosselPronto = '1';
    const passo = () => {
      const item = $('.carrossel__item', trilho);
      return item ? Math.max(item.offsetWidth, trilho.clientWidth - item.offsetWidth) : trilho.clientWidth;
    };
    const estado = () => {
      if (anterior) anterior.disabled = trilho.scrollLeft < 8;
      if (proximo) proximo.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 8;
    };
    anterior?.addEventListener('click', () => trilho.scrollBy({ left: -passo(), behavior: 'smooth' }));
    proximo?.addEventListener('click', () => trilho.scrollBy({ left: passo(), behavior: 'smooth' }));
    trilho.addEventListener('scroll', atraso(estado, 60), { passive: true });
    estado();
  };
  $$('[data-carrossel]').forEach(iniciarCarrossel);

  /* ── Faixa de capas em movimento contínuo ─────────────────────── */
  $$('[data-faixa]').forEach((faixa) => {
    const trilho = $('.faixa__trilho', faixa);
    if (!trilho || reduzirMovimento.matches || trilho.children.length < 4) return;
    $$('li', trilho).forEach((li) => {
      const copia = li.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      $$('a', copia).forEach((a) => (a.tabIndex = -1));
      trilho.appendChild(copia);
    });
    const largura = trilho.scrollWidth / 2;
    faixa.style.setProperty('--duracao-faixa', `${Math.round(largura / 38)}s`);
    faixa.classList.add('ativa');
  });

  /* ── Vídeos do Remotion: tocam só quando aparecem na tela ─────── */
  const iniciarVideos = () => {
    $$('[data-video-loop] video').forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      if (reduzirMovimento.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(([entrada]) => {
        if (entrada.isIntersecting) {
          if (video.hasAttribute('data-video-preguicoso')) {
            $$('source[data-src]', video).forEach((s) => {
              s.src = s.dataset.src;
              s.removeAttribute('data-src');
            });
            video.removeAttribute('data-video-preguicoso');
            video.load();
          }
          video.play().catch(() => {});
        } else video.pause();
      }, { rootMargin: '200px 0px' }).observe(video);
    });
  };
  iniciarVideos();

  /* ── Filtros, ordenação e "carregar mais" sem recarregar ──────── */
  const secaoResultados = () => $('[data-colecao]');
  const carregarResultados = async (url, { empurrar = true } = {}) => {
    const secao = secaoResultados();
    if (!secao) return (window.location.href = url);
    const alvo = new URL(url, window.location.origin);
    const grade = $('[data-grade]', secao);
    grade?.classList.add('atualizando');
    $$('dialog.gaveta[open]', secao).forEach((d) => d.close());
    try {
      const pedido = new URL(alvo);
      pedido.searchParams.set('section_id', secao.dataset.secao);
      const resposta = await fetch(pedido);
      const doc = parseHTML(await resposta.text());
      const novo = $('[data-resultados]', doc);
      const atual = $('[data-resultados]', secao);
      if (novo && atual) atual.replaceWith(novo);
      if (empurrar) window.history.pushState({ resultados: true }, '', alvo.pathname + alvo.search);
      revelar(secao);
    } catch {
      window.location.href = alvo.href;
    }
  };
  const urlDoFormulario = (form) => {
    const dados = new FormData(form);
    const params = new URLSearchParams();
    for (const [chave, valor] of dados) if (String(valor).trim() !== '') params.append(chave, valor);
    return `${window.location.pathname}?${params.toString()}`;
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-form-filtros], [data-form-ordenar]');
    if (!form || !secaoResultados()) return;
    e.preventDefault();
    carregarResultados(urlDoFormulario(form));
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-ordenar]')) carregarResultados(urlDoFormulario(e.target.form));
  });
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('.filtro-pilula, .filtros-ativos__limpar, .gaveta-filtros .gaveta__rodape a');
    if (link && secaoResultados()) {
      e.preventDefault();
      carregarResultados(link.href);
      return;
    }
    const mais = e.target.closest('[data-carregar-mais]');
    if (!mais) return;
    e.preventDefault();
    const secao = secaoResultados();
    mais.classList.add('carregando');
    try {
      const pedido = new URL(mais.href, window.location.origin);
      pedido.searchParams.set('section_id', secao.dataset.secao);
      const doc = parseHTML(await (await fetch(pedido)).text());
      const gradeNova = $('[data-grade]', doc);
      const gradeAtual = $('[data-grade]', secao);
      $$(':scope > li', gradeNova).forEach((li) => gradeAtual.appendChild(li));
      const navNova = $('.paginacao', doc);
      const navAtual = $('.paginacao', secao);
      if (navAtual) navNova ? navAtual.replaceWith(navNova) : navAtual.remove();
      revelar(gradeAtual);
    } catch {
      window.location.href = mais.href;
    }
  });
  window.addEventListener('popstate', () => {
    if (secaoResultados()) carregarResultados(window.location.href, { empurrar: false });
  });

  /* ── Recomendações na página do livro ─────────────────────────── */
  $$('[data-recomendacoes]').forEach(async (secao) => {
    if (!secao.dataset.url) return;
    try {
      const doc = parseHTML(await (await fetch(secao.dataset.url)).text());
      const nova = $('[data-recomendacoes]', doc);
      if (!nova || !nova.innerHTML.trim()) {
        secao.closest('.shopify-section')?.setAttribute('hidden', '');
        return;
      }
      secao.innerHTML = nova.innerHTML;
      iniciarCarrossel(secao);
      revelar(secao);
    } catch {
      /* sem recomendações: a seção fica vazia */
    }
  });

  /* ── Transição da capa entre o cartão e a página do livro ─────── */
  const limparNomesTransicao = () => $$('.card__capa').forEach((img) => (img.style.viewTransitionName = ''));
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.card a[href]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    limparNomesTransicao();
    const capa = $('.card__capa', link.closest('.card'));
    if (capa) capa.style.viewTransitionName = 'capa-principal';
  });
  window.addEventListener('pageshow', limparNomesTransicao);

  /* ── Início ───────────────────────────────────────────────────── */
  revelar();
  // no editor de temas, seções recarregadas precisam ser iniciadas de novo
  document.addEventListener('shopify:section:load', (e) => {
    const raiz = e.target;
    $$('[data-produto]', raiz).forEach(iniciarProduto);
    $$('[data-carrossel]', raiz).forEach(iniciarCarrossel);
    iniciarVideos();
    revelar(raiz);
  });
})();
